import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryCreditHumanApplicationHandoffDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Reopen an Existing Loan Application handoff. Telemetry may update; the
 * application snapshot never resets.
 */
export default function useReopenBatteryCreditHumanApplication(): UseMutationResult<
  BatteryCreditHumanApplicationHandoffDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      batteryProposalService.reopenCreditHumanApplication(
        proposalId,
        applicationId,
      ),
    onSuccess: (handoff, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        handoff.financing,
      )
    },
  })
}
